import { createVanIconComponent } from "./van"

const Tosend = createVanIconComponent("tosend")
export default Tosend
